import {useQuery} from "@tanstack/react-query"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {eventTypeService, outcomeService} from "services"

const INITIAL_DATA: any[] = []

export const useAllCalendarEventTypes = () => {
    const query = useQuery(
        ["all-calendar-event-types"],
        async () => {
            const {data} = await eventTypeService.getAll({range: {limit: UNLIMITED_PAGE_SIZE, offset: 0}})
            return data
        },
        {
            staleTime: 30 * 60 * 1000 // 30 minutes
        }
    )

    return {eventTypes: query.data ?? INITIAL_DATA, isLoading: query.isFetching}
}
